var formControlWrapStyle = {"z-form-control-wrap":"z-form-control-wrap"};

export { formControlWrapStyle as default };
//# sourceMappingURL=FormControlWrap.module.scss.js.map
